module.exports = __webpack_public_path__ + "static/media/fem_1.15c71986.png";